module.exports = __webpack_public_path__ + "img/404.9509a7b5.png";